import { type PropsWithChildren } from 'react'

import { ConversationChipStyled } from './styles/ConversationChipStyled'

export interface IConversationChipProps {
  analyticsId: string
  onClick: () => void
  disabled?: boolean
}

export const ConversationChip = ({
  analyticsId,
  onClick,
  disabled = false,
  children,
}: PropsWithChildren<IConversationChipProps>) => (
  <ConversationChipStyled
    type='button'
    analyticsId={analyticsId}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </ConversationChipStyled>
)
